<template lang="pug">
.language-wrap
  .lang-c.nb-lang-toggle
    button.language-btn.nb-lang(type='button' :class="{'show': getLanguage === 'en', 'hide': getLanguage !=='en'}" @click="setLanguage('ph')")
      img(src='/new/img/lang-en.png')
      span EN
    button.language-btn.nb-lang(type='button' :class="{'show': getLanguage === 'ph', 'hide': getLanguage !=='ph'}" @click="setLanguage('en')")
      span PH
      img(src='/new/img/lang-ph.png')
</template>
<script>
export default{
  computed: {
    getLanguage() {
      return this.$store.getters.language || "en";
    },
  },
  methods:{
    setLanguage(payload) {
      this.$store.dispatch("user/setLanguage", payload);
      this.showLang = false;
    },
  }
}
</script>